module.exports = __webpack_public_path__ + "static/media/headerLogo.5fc83ade.png";